import * as React from 'react';

interface DriverTab {
    loading: boolean;
}

interface DriverTabProps {
    tab: string;
    truckId: number;
}

export default class DriverTabData extends React.Component<DriverTabProps, DriverTab> {
    constructor(props: DriverTabProps) {
        super(props);

        this.state = {
            loading: false
        };

    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        return (
            <div>
                {this.props.children}
                <div className="bottom-nav">
                    <a className="mobile-icon-white" href={"/driverjobs"}>
                        <span className="fas fa-list-alt mobileMenuSize alignIconCenter"></span>
                        <span>Jobs</span>
                    </a>
                    <a className="mobile-icon-white" href={"/driverteam/" + this.props.truckId}>
                        <span className="fas fa-users mobileMenuSize alignIconCenter"></span>
                        <span>Team</span>
                    </a>
                    <a className="mobile-icon-white" href={"/drivertruckcheck/" + this.props.truckId}>
                        <span className="fas fa-truck-moving mobileMenuSize alignIconCenter"></span>
                        <span>Truck Check</span>
                    </a>
                    <a className="mobile-icon-white" href={"/drivertoolcheck/" + this.props.truckId + "/1"}>
                        <span className="fas fa-screwdriver-wrench mobileMenuSize alignIconCenter"></span>
                        <span>Tool Check</span>
                    </a>
                    <a className="mobile-icon-white" href={"/drivertomorrowjobs/" + this.props.truckId}>
                        <i className="fa-solid fa-truck-arrow-right mobileMenuSize alignIconCenter"></i>
                        <span>Tomorrow</span>
                    </a>
                </div>
            </div>
        )
    }
}

